import React from 'react';
import './AuthBackground.scss';

const AuthBackground = (props) => (
	<div className='AuthBackground'>
		<div className='logo'>
			<img src='./assets/images/svg/logo_white.svg' />
			<div className='desc'>Mock Exam: Leading SAFe</div>
		</div>
		<div className='content'>
			{props.children}
		</div>
		<div  className='auth-footer'>
			<p className='copyright'>&copy; 2021 <span className="medium">LeanWisdom</span></p>
			<div className="brand-logo">
			<a className="goodux-logo" href="http://goodux.in/" target="_blank">
				<img   src='./assets/images/svg/uxuibygood.svg' />
			</a>
				<div className="goodux-name">" UX . UI by GoodUX "</div>
			</div>
		</div>
	</div>
);

export default AuthBackground;



// WEBPACK FOOTER //
// ./components/Auth/AuthBackground/AuthBackground.js